import { render, staticRenderFns } from "./dingdingrelationsys.vue?vue&type=template&id=2ed67d50&scoped=true&"
import script from "./dingdingrelationsys.vue?vue&type=script&lang=js&"
export * from "./dingdingrelationsys.vue?vue&type=script&lang=js&"
import style0 from "./dingdingrelationsys.vue?vue&type=style&index=0&id=2ed67d50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed67d50",
  null
  
)

export default component.exports